export default "__VITE_ASSET__ByuSVj8D__"